import React from 'react'
import FontAwesome from 'react-fontawesome'
import { withRouter } from 'react-router-dom'
import CustomButton from '../../buttons/CustomButton'
import './GroupEdition.scss'
import GroupEditionTable from './GroupEditionTable'

const GroupEdition = ({ history }) => (
  <div className="container-fluid group-edition">
    <GroupEditionTable />
    <div className="row justify-content-center p-4">
      <CustomButton onClick={() => history.push('/configuration')} icon={<FontAwesome name="arrow-left" />} small secondary />
    </div>
  </div>
)
export default withRouter(GroupEdition)
